import React from "react";

const DataPrivacy = () => {
  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "8px",
        maxHeight: "70vh",
      }}
    >
      <h2
        style={{
          fontSize: "24px",
          color: "#007bff",
          marginBottom: "20px",
          fontWeight: "bold",
        }}
      >
        Privacy Statement
      </h2>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>
          1. Name and address of the data controller
        </h4>
        <p>
          1. The data controller pursuant to the General Data Protection
          Regulation, the Member States’ national data protection laws and any
          other applicable data protection regulations is:
        </p>
        <p>
          Oleg Shitsel <br />
          Graf-Sponeck-Straße 1 <br />
          28327 Bremen <br />
          Email: support@bambkuss.com
          <br />
          Phone: +4915731385296
        </p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>
          2. Information on data processing
        </h4>
        <p>
          1. We collect and process personal data of our users only to the
          extent necessary for the presentation of a functional website and our
          content and services. In addition, after users register and log in
          cookies are set and personal data is collected and used. The
          collection and use of our users’ personal data is regularly carried
          out only with the user’s consent. An exception applies in those cases
          where prior consent cannot be obtained for valid reasons and the
          processing of the data is permitted by law.
        </p>
        <p>
          Information on the scope, purpose and legal basis of the processing of
          personal data can be found in the relevant sections of this privacy
          policy. The personal data of the data subject will be erased or
          blocked, as soon as the purpose for which it was stored no longer
          applies. Data may also be stored if this has been provided for by the
          European or national legislator in EU regulations, laws or other
          provisions to which the controller is subject. The data will also be
          blocked or erased if a storage period prescribed by the aforementioned
          standards expires, unless there is a need for further storage of the
          data for the conclusion or fulfilment of a contract.
        </p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>
          3. Use of cookies
        </h4>
        <p>
          1. Our website uses cookies, but they are only activated after
          registration and login.
        </p>
        <p>
          Cookies are text files that are stored in or by the Internet browser
          on the user's computer system. When a user accesses a website, a
          cookie may be stored on the user's operating system. This cookie
          contains a distinctive character string which allows for unique
          identification of the browser when the website is accessed again. We
          use cookies to make our website more user-friendly. Some functions of
          our website cannot be offered without the use of cookies. A technical
          requirement for the performance of certain functions of our website is
          that the accessing browser can still be identified after a page
          change. The user data collected by technically necessary cookies is
          not used to create user profiles.
        </p>
        {/* <-- This is the new optional cookies addition --> */}
        <p>
          <b>Optional cookies:</b> These include analytics cookies and cookies
          that improve the user experience. They are only set if the user
          explicitly consents via the GDPR banner. Users can manage or withdraw
          consent at any time by using the banner or adjusting their browser
          settings.
        </p>
        <p>
          Please note that disabling optional cookies may limit some
          functionalities and analytics tracking.
        </p>
        <p>
          Moreover, the use of our services is free of charge for customers,
          with advertising as the funding mechanism. Our free website can
          therefore only exist with advertising revenue.
        </p>
        <p>
          The above-listed purposes constitute our legitimate interest in the
          processing of personal data in accordance with Art. 6 para. 1 lit. f)
          GDPR.
        </p>
        <p>
          Cookies are stored on the user's computer and transmitted to our site.
          As a user, you therefore have full control over the use of cookies.
          You can deactivate or restrict the transmission of cookies by changing
          the settings in your Internet browser. Cookies that have already been
          stored can be erased at any time. This can also be done automatically.
          If cookies are deactivated for our website, it may no longer be
          possible to use all the functions of the website to their full extent.
        </p>
        <p>
          Please note that even after adjusting your browser settings, you may
          still be informed individually about the setting of cookies and can
          therefore decide whether to accept them.
        </p>
        <p>
          You can find more information on changing your cookie settings in the
          help menu of your browser under the following links:
        </p>
        <ul>
          <li>Chrome</li>
          <li>Safari</li>
          <li>Firefox</li>
          <li>Internet Explorer</li>
          <li>Opera</li>
        </ul>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>
          4. Registration and contract execution
        </h4>
        <p>
          1. To use our services, you have to register first. The data is
          entered into an input screen, transmitted to us and stored. The data
          collected can be found in the respective input screen. Registration is
          required to access all content and services on our website. The user's
          consent to the processing of this data is obtained during the
          registration process. The legal basis for the processing of the data
          is Art. 6 para. 1 lit. a) GDPR when the user has given their consent.
        </p>
        <p>
          If the data collection serves to fulfil the contract to which the user
          is a party or to carry out pre-contractual measures, the additional
          legal basis for the processing of the data is Art. 6 para. 1 lit. b)
          GDPR. The same applies to the transfer of your payment data to our
          principal bank.
        </p>
        <p>
          The data will be erased as soon as it is no longer necessary for the
          purpose for which it was collected. This is the case for data
          collected during the registration process if the registration on our
          website is cancelled or modified. For data collected during the
          registration process for the fulfilment of a contract or for the
          implementation of pre-contractual measures, this is the case when the
          data is no longer required for the execution of the contract. Even
          after conclusion of the contract, it may be necessary to store
          personal data of the contractual partner in order to fulfil
          contractual or legal obligations.
        </p>
        <p>
          As a user, you have the option of cancelling your registration at any
          time by sending us an informal email. You can have the data stored
          about you changed at any time by sending us an informal email. If the
          data is necessary for the fulfilment of a contract or for the
          implementation of pre-contractual measures, premature erasure of the
          data is only possible if there are no contractual or legal obligations
          preventing erasure.
        </p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>5. Contact</h4>
        <p>
          If you contact us by email, the personal data you provide in your
          email will be stored. This data will not be passed on to third
          parties. The data will be used exclusively for processing the
          conversation.
        </p>
        <p>
          The legal basis for the processing of data transmitted in the course
          of sending an email is Art. 6 para. 1 lit. f) GDPR. If the email
          contact is aimed at concluding a contract, the additional legal basis
          for the processing is Art. 6 para. 1 lit. b) GDPR. When processing
          personal data from the email, the necessary legitimate interest in
          processing the data also applies here.
        </p>
        <p>
          The data will be erased as soon as it is no longer necessary for the
          purpose for which it was collected. For personal data sent by email,
          this is the case when the respective conversation with the user has
          ended. The conversation is ended when it can be inferred from the
          circumstances that the matter in question has been conclusively
          clarified. The additional personal data collected during the sending
          process will be erased after a period of seven days at the latest.
        </p>
        <p>
          If the user contacts us by email, they can object to the storage of
          their personal data at any time. In such a case, the conversation
          cannot be continued. The revocation can be made by an informal
          declaration to the email address specified in above point 1. In this
          case, all personal data stored in the course of the contact will be
          erased.
        </p>
      </section>

      <section>
        <h4 style={{ fontWeight: "bold", marginTop: "16px" }}>
          6. Rights of data subjects
        </h4>
        <p>
          If your personal data is processed, you are a data subject within the
          meaning of the GDPR and you have the following rights vis-à-vis the
          controller:
        </p>
        <ul>
          <li>
            <b>Right to information:</b> You can request confirmation from the
            data controller as to whether personal data concerning you is being
            processed by the data controller. In addition, you have the right to
            information about the purpose, the categories of personal data, the
            recipients, the planned duration of storage and the existence of
            further rights such as correction of the data or the existence of a
            right of appeal to a supervisory authority.
          </li>
          <li>
            <b>Right to rectification:</b> You have the right to obtain from the
            controller rectification of personal data concerning you that is
            inaccurate or incomplete. The controller shall carry out the
            rectification without undue delay.
          </li>
          <li>
            <b>Right to restriction of processing:</b> You have the right to
            obtain restriction of the processing of your personal data for as
            long as the accuracy of your data is being verified, if you oppose
            the erasure of your personal data due to unlawful processing and
            request the restriction of the processing of your data instead, if
            you require your data for the assertion, exercise or defence of
            legal claims after we no longer need this data for the purpose for
            which it was collected, or if you have objected on grounds relating
            to your particular situation, as long as it is not yet clear whether
            our legitimate reasons prevail. Where the processing of your
            personal data has been restricted, such data may – with the
            exception of storage – only be processed with your consent or for
            the assertion, exercise or defence of legal claims or for the
            protection of the rights of another natural or legal person or for
            reasons of important public interest of the Union or of a Member
            State. If the restriction of processing has been restricted, you
            will be informed by the data controller before the restriction of
            processing is lifted.
          </li>
          <li>
            <b>Right to erasure:</b> You may request that the controller erase
            personal data concerning you without undue delay if and to the
            extent that the conditions for erasure are met. The controller is
            obliged to erase such data without delay. Where the controller has
            made the personal data concerning you public and is obliged pursuant
            to Art. 17(1) GDPR to erase it, the controller, taking account of
            available technology and the cost of implementation, shall take
            reasonable steps, including technical measures, to inform
            controllers which are processing the personal data that the data
            subject has requested the erasure by such controllers of any links
            to, or copy or replication of, those personal data. The right to
            erasure does not apply if the processing is necessary (1) for
            exercising the right of freedom of expression and information; (2)
            for compliance with a legal obligation which requires processing in
            accordance with Union or Member State law to which the controller is
            subject or for the performance of a task carried out in the public
            interest or in the exercise of official authority vested in the
            controller; (3) for reasons of public interest in the area of public
            health pursuant to Art. 9 para. 2 lit. h) and i) and Art. 9 para. 3
            GDPR; (4) for archiving purposes in the public interest, scientific
            or historical research purposes or statistical purposes in
            accordance with Article 89(1) of the GDPR, insofar as the right
            referred to in section a) is likely to render impossible or
            seriously impair the achievement of the objectives of this
            processing, or (5) for the establishment, exercise or defence of
            legal claims.
          </li>
          <li>
            <b>Right to notification:</b> You have the right to be informed by
            the controller of the recipients to whom the controller has
            disclosed that you have exercised your right to rectification,
            erasure or restriction of processing vis-à-vis the controller.
          </li>
          <li>
            <b>Right to data portability:</b> You have the right to receive the
            personal data concerning you that you have provided to the
            controller in a structured, commonly used and machine-readable
            format.
          </li>
          <li>
            <b>Right to object:</b> You have the right to object, on grounds
            relating to your particular situation, to the processing of personal
            data concerning you which is based on Article 6(1)(e) or (f) of the
            GDPR; this also applies to profiling based on these provisions.
          </li>
          <li>
            <b>Right to withdraw your consent to data processing:</b> You have
            the right to withdraw your consent to data processing at any time.
            Withdrawing your consent does not affect the lawfulness of
            processing based on consent before its withdrawal.
          </li>
          <li>
            <b>
              Right to object to automated individual decision-making, including
              profiling:
            </b>{" "}
            You have the right not to be subject to a decision based solely on
            automated processing, including profiling, which produces legal
            effects concerning you or similarly significantly affects you.
          </li>
          <li>
            <b>Right to lodge a complaint with a supervisory authority:</b>{" "}
            Without prejudice to any other administrative or judicial remedy,
            you have the right to lodge a complaint with a supervisory
            authority, in particular in the Member State of your habitual
            residence, place of work or place of the alleged infringement if you
            consider that the processing of personal data relating to you
            infringes the GDPR.
          </li>
        </ul>
      </section>

      <p style={{ marginTop: "24px", fontStyle: "italic" }}>
        End of the privacy policy
      </p>
    </div>
  );
};

export default DataPrivacy;
